import React, { useRef, useState } from 'react';
import styled from 'styled-components';
import { products } from '../data/products';

// Carrousel des formats Tartina — défilement horizontal avec flèches + points.
const ProductsCarousel = () => {
  const trackRef = useRef(null);
  const [active, setActive] = useState(0);

  const scrollToIndex = (i) => {
    const track = trackRef.current;
    if (!track) return;
    const clamped = Math.max(0, Math.min(products.length - 1, i));
    const card = track.children[clamped];
    if (card) {
      track.scrollTo({ left: card.offsetLeft - track.offsetLeft, behavior: 'smooth' });
    }
    setActive(clamped);
  };

  const onScroll = () => {
    const track = trackRef.current;
    if (!track) return;
    let closest = 0;
    let min = Infinity;
    [...track.children].forEach((card, i) => {
      const d = Math.abs(card.offsetLeft - track.offsetLeft - track.scrollLeft);
      if (d < min) { min = d; closest = i; }
    });
    setActive(closest);
  };

  return (
    <Wrap>
      <Track ref={trackRef} onScroll={onScroll}>
        {products.map((p) => (
          <Card key={p.id}>
            <Tag>{p.tag}</Tag>
            <ImgWrap><img src={p.image} alt={`Tartina ${p.name} ${p.size}`} /></ImgWrap>
            <Name>{p.name}</Name>
            <Size>{p.size}</Size>
            <Desc>{p.description}</Desc>
          </Card>
        ))}
      </Track>

      <Controls>
        <NavBtn type="button" aria-label="Produit précédent" onClick={() => scrollToIndex(active - 1)} disabled={active === 0}>
          <i className="ti ti-chevron-left" aria-hidden="true" />
        </NavBtn>
        <Dots>
          {products.map((p, i) => (
            <Dot key={p.id} $active={i === active} onClick={() => scrollToIndex(i)} aria-label={`Voir ${p.name}`} />
          ))}
        </Dots>
        <NavBtn type="button" aria-label="Produit suivant" onClick={() => scrollToIndex(active + 1)} disabled={active === products.length - 1}>
          <i className="ti ti-chevron-right" aria-hidden="true" />
        </NavBtn>
      </Controls>
    </Wrap>
  );
};

const Wrap = styled.div``;
const Track = styled.div`
  display: flex; gap: 22px; overflow-x: auto; scroll-snap-type: x mandatory;
  padding: 4px 4px 10px; -ms-overflow-style: none; scrollbar-width: none;
  &::-webkit-scrollbar { display: none; }
`;
const Card = styled.div`
  position: relative; flex: 0 0 240px; scroll-snap-align: start;
  background: #fff; border: 1px solid ${({ theme }) => theme.colors.border};
  border-radius: 22px; padding: 20px 18px; text-align: center;
  transition: transform .2s ease, box-shadow .2s ease;
  &:hover { transform: translateY(-4px); box-shadow: ${({ theme }) => theme.shadows.md}; }
`;
const Tag = styled.span`
  position: absolute; top: 14px; left: 14px;
  background: ${({ theme }) => theme.colors.secondary}; color: ${({ theme }) => theme.colors.chocolate};
  font-weight: 800; font-size: 0.68rem; padding: 4px 10px; border-radius: 999px;
`;
const ImgWrap = styled.div`
  height: 160px; display: flex; align-items: center; justify-content: center; margin-bottom: 12px;
  img { max-height: 100%; max-width: 100%; object-fit: contain; }
`;
const Name = styled.h3`
  font-size: 1.1rem; color: ${({ theme }) => theme.colors.chocolate}; margin-bottom: 2px;
`;
const Size = styled.div`
  display: inline-block; background: ${({ theme }) => theme.colors.cream}; color: ${({ theme }) => theme.colors.tertiary};
  font-weight: 800; font-size: 0.8rem; padding: 4px 12px; border-radius: 999px; margin-bottom: 10px;
`;
const Desc = styled.p`
  color: ${({ theme }) => theme.colors.textSecondary}; font-size: 0.88rem; line-height: 1.5; margin: 0;
`;
const Controls = styled.div`
  display: flex; align-items: center; justify-content: center; gap: 16px; margin-top: 8px;
`;
const NavBtn = styled.button`
  width: 40px; height: 40px; border-radius: 50%; cursor: pointer;
  border: 2px solid ${({ theme }) => theme.colors.border}; background: #fff; color: ${({ theme }) => theme.colors.primary};
  display: inline-flex; align-items: center; justify-content: center; font-size: 1.2rem;
  transition: all .15s ease;
  &:hover:not(:disabled) { border-color: ${({ theme }) => theme.colors.primary}; transform: scale(1.06); }
  &:disabled { opacity: 0.35; cursor: not-allowed; }
`;
const Dots = styled.div`display: flex; gap: 8px;`;
const Dot = styled.button`
  width: 9px; height: 9px; border-radius: 50%; padding: 0; cursor: pointer; border: none;
  background: ${({ $active, theme }) => ($active ? theme.colors.primary : theme.colors.border)};
  transition: all .15s ease;
`;

export default ProductsCarousel;
